export const itemsOrder  = [
    { value: '{"empleado.nombre": "ASC", "empleado.apellido1": "ASC", "empleado.apellido2": "ASC"}', label: "Empleados" },
    { value: '{"dia": "DESC"}', label: "Día (De más reciente a más antiguo)" },
    { value: '{"dia": "ASC"}', label: "Día (De más antiguo a más reciente" },
]